import { i18n } from '../../i18n';
import { request } from 'beans-admin-plugin';



export const filterColumnsHash = {
  title_cont: {
    label: i18n.t('event.title'),
    renderCell: {
      component: 'input'
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('event.id'),
    width: 80,
  },
  address: {
    label: i18n.t('event.address'),
  },
  title: {
    label: i18n.t('event.title'),
  },
  application_id: {
    label: i18n.t('event.application'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.application) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'applications.show', params: { id: row.application_id } }}>{row.application.name}</bean-link>
    },
  },
  event_category_id: {
    label: i18n.t('event.eventCategory'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.event_category) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'event_categories.show', params: { id: row.event_category_id } }}>{row.event_category.name}</bean-link>
    },
  },
  created_at: {
    label: i18n.t('event.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  end_at: {
    label: i18n.t('event.endAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  start_at: {
    label: i18n.t('event.startAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('event.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  images: {
    label: i18n.t('event.images'),
    renderCell: 'storageAttachment',
  },
  description: {
    label: i18n.t('event.description'),
    renderCell: 'html',
  },
}

export const formColumnsHash = {
  address: {
    label: i18n.t('event.address'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  title: {
    label: i18n.t('event.title'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  event_category_id: {
    label: i18n.t('event.eventCategory'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        xRemotePreload: async () => {
          const { data } = await request.get('/event_categories', { params: { per_page: 100 } });
          return data.map(({ id, name }) => ({ value: id, label: name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/event_categories', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
  end_at: {
    label: i18n.t('event.endAt'),
    renderCell: {
      required: true,
      component: 'dateTimePicker',
    }
  },
  start_at: {
    label: i18n.t('event.startAt'),
    renderCell: {
      required: true,
      component: 'dateTimePicker',
    }
  },
  images: {
    label: i18n.t('event.images'),
    renderCell: {
      component: 'upload',
    }
  },
  description: {
    label: i18n.t('event.description'),
    renderCell: {
      component: 'editor',
    }
  },
}
